import toast from "@/components/toast/toast.vue"
export default (Vue) => {
    let toastComp = Vue.extend(toast);
    function showToast(msg , duration = 1500){
        let toastDom = new toastComp({
            data(){
                return{
                    show:true,
                    msg
                }
            }
        }).$mount()
        document.body.appendChild(toastDom.$el);
        setTimeout(() => {
            toastDom.show = false
        }, duration)
    }
    Vue.prototype.$toast = showToast;
}